import clsx from 'clsx';
import { Dayjs } from 'dayjs';
import React, { useState } from 'react';
import { BundleJson } from 'types/bundleTypes';
import { Region } from 'types/orderTypes';
import { PlannerBundle, PlannerOrder } from '../utils/usePlannerData';
import { BundleItem } from './Bundle/BundleItem';
import { BundleMenu } from './Bundle/BundleMenu';

interface PlannerToolsBundleProps {
  region: Region;
  activeDate: Dayjs;
  bundles: PlannerBundle[];
  fetchedBundles: BundleJson[];
  selectedOrderCount: number;
  refetching: boolean;
  selectedOrders?: PlannerOrder[];
  selectedOrderIds?: string[];
  reFetch: () => void;
}

export const PlannerToolsBundle = ({
  reFetch,
  ...props
}: PlannerToolsBundleProps) => {
  const [selectedDraftBundles, setSelectedDraftBundles] = useState<string[]>(
    []
  );

  /* `activeBundleMap` used by the BundleItem's TopMenu to determine which map is placed on the top */
  const [activeBundleMap, setActiveBundleMap] = useState<string>();

  const updateSelectedDraftBundles = (
    newSelectedDraftBundles: Array<string>
  ) => {
    setSelectedDraftBundles(newSelectedDraftBundles);
  };

  const onInteractingWithBundleMap = (bundleId: string) => {
    setActiveBundleMap(bundleId);
  };

  return (
    <div className="tools__bundles">
      <strong>Bundles</strong>

      <div className="tools-line" />

      <BundleMenu
        region={props.region}
        bundles={props.bundles}
        selectedDraftBundles={selectedDraftBundles}
        selectedOrderCount={props.selectedOrderCount}
        refetching={props.refetching}
        selectedOrders={props.selectedOrders}
        selectedOrderIds={props.selectedOrderIds}
        updateSelectedDraftBundles={updateSelectedDraftBundles}
        reFetch={reFetch}
      />

      <div
        style={{ height: 10, borderRadius: 8, margin: '8px 0' }}
        className={clsx(props.refetching && 'gradient-fade-loading')}
      />

      {props.fetchedBundles.map(bundle => (
        <div key={bundle.id} className="planner-map-draft-list" id={bundle.id}>
          <BundleItem
            region={props.region}
            bundle={bundle}
            otherBundles={props.fetchedBundles.filter(
              otherBundle => otherBundle.id !== bundle.id
            )}
            activeDate={props.activeDate}
            selectedDraftBundles={selectedDraftBundles}
            activeBundleMap={activeBundleMap}
            refetching={props.refetching}
            updateSelectedDraftBundles={updateSelectedDraftBundles}
            reFetch={reFetch}
            onInteractingWithBundleMap={onInteractingWithBundleMap}
          />
        </div>
      ))}

      {props.fetchedBundles?.length <= 0 && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingBottom: 2,
            backgroundColor: '#f0f0f0',
          }}
        >
          No draft bundles
        </div>
      )}
    </div>
  );
};
